"use client";

import FaqSection from "@/components/shared/FaqSection";
import Footer from "@/components/shared/Footer";
import NextCallsSection from "@/components/shared/NextCallsSection";
import PricingSection from "@/components/shared/PricingSection";
import TopNav from "@/components/shared/TopNav";
import WallSection from "@/components/shared/WallSection";
import FeaturesSection from "./components/FeaturesSection";

export default function PricingPageComponent() {
  return (
    <div>
      <TopNav />
      <main className="pt-10 lg:pt-0">
        <PricingSection />
        <FeaturesSection />
        <WallSection />
        <FaqSection />
        <NextCallsSection />
      </main>
      <Footer />
    </div>
  );
}
